import { render, staticRenderFns } from "./MarketingMaintain.vue?vue&type=template&id=48a04196&scoped=true"
import script from "./MarketingMaintain.vue?vue&type=script&lang=js"
export * from "./MarketingMaintain.vue?vue&type=script&lang=js"
import style0 from "./MarketingMaintain.vue?vue&type=style&index=0&id=48a04196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a04196",
  null
  
)

export default component.exports